
import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/loginStore';
import { loginSchema } from '../../schemes/LoginForm';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import AppTheme from '../../shared-theme/AppTheme';
import ColorModeSelect from '../../shared-theme/ColorModeSelect';
import LoginIcon from '@mui/icons-material/Login';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { useVendasStore } from '../../store/VendasStore';
import { useTerminaltore } from '../../store/TerminaisStores'
import { useCryptoStore } from '../../store/CriptoStore';
import { useProdutosStore } from '../../store/ProdutosStore';


const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
        maxWidth: '450px',
    },
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
        boxShadow:
            'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
    height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
    minHeight: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
        backgroundImage:
            'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
        backgroundRepeat: 'no-repeat',
        ...theme.applyStyles('dark', {
            backgroundImage:
                'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
        }),
    },
}));



export default function SignIn(props) {
    const { login, carregando, progresso } = useAuthStore();
    const { GetVendas } = useVendasStore();
    const { GetEstatisticasDosTerminais } = useTerminaltore();
    const { Cripto } = useCryptoStore();

    const navigate = useNavigate();

    const [nomeError, setnomeError] = useState(false);
    const [nomeErrorMessage, setnomeErrorMessage] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [nome, setNome] = useState('');
    const [senha, setSenha] = useState('');

    const { FiltrarProdutosParaGrafico } = useProdutosStore();
    function handleSubmit() {

        const result = loginSchema.safeParse({ nome, senha });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nome?._errors?.length) {
                setnomeError(true);
                setnomeErrorMessage(errors.nome._errors[0]);
            } else {
                setnomeError(false);
                setnomeErrorMessage('');
            }

            if (errors.senha?._errors?.length) {
                setPasswordError(true);
                setPasswordErrorMessage(errors.senha._errors[0]);
            } else {
                setPasswordError(false);
                setPasswordErrorMessage('');
            }

            return;
        }

        // Se chegou aqui, os dados estão válidos
        setnomeError(false);
        setnomeErrorMessage('');
        setPasswordError(false);
        setPasswordErrorMessage('');

        login(nome, senha, navigate);
    }

    function teste() {

        // FiltrarProdutosParaGrafico()
    }


    return (
        <AppTheme {...props}>
            {/* <Button
                onClick={() => { teste() }}
            >
                teste
            </Button> */}
            <CssBaseline enableColorScheme />
            <SignInContainer direction="column" justifyContent="space-between">
                <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
                <Card variant="outlined">
                    {/* <SitemarkIcon /> */}
                    <Typography
                        component="h1"
                        variant="h4"
                        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                    >
                        Login
                    </Typography>
                    <Box
                        component="form"
                        noValidate
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: 2,
                        }}
                    >
                        <FormControl>
                            <FormLabel htmlFor="email">Nome de usuário</FormLabel>
                            <TextField
                                autoComplete="off"
                                error={nomeError}
                                helperText={nomeErrorMessage}
                                id="nome"
                                type="text"
                                placeholder="Digite seu nome"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                color={nomeError ? 'error' : 'primary'}
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="password">Senha</FormLabel>
                            <TextField
                                autoComplete="off"
                                error={passwordError}
                                helperText={passwordErrorMessage}
                                placeholder="Digite sua senha"
                                type="password"
                                id="password"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                color={passwordError ? 'error' : 'primary'}
                                value={senha}
                                onChange={e => setSenha(e.target.value)}
                            />
                        </FormControl>
                        <Button
                            style={{ color: 'white', background: 'black' }}
                            fullWidth
                            variant="contained"
                            type="button"
                            onClick={handleSubmit}
                            endIcon={carregando ? <CircularProgress size={20} color="inherit" /> : <LoginIcon></LoginIcon>}
                            disabled={carregando}
                        >
                            {progresso}
                        </Button>
                    </Box>
                </Card>
            </SignInContainer>
        </AppTheme>
    );
}

